/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  productmanager: {
    '& .button': {
      width: 'auto',
      minWidth: 'auto !important',
      padding: pxToEm(16)
    },
    '& .sectiongroupv2': {
      width: '50%',
      '& .header': { width: '100%'}
    }
  }
});
